import { render, staticRenderFns } from "./BottomList.vue?vue&type=template&id=ed3266b2&scoped=true&"
import script from "./BottomList.vue?vue&type=script&lang=js&"
export * from "./BottomList.vue?vue&type=script&lang=js&"
import style0 from "./BottomList.vue?vue&type=style&index=0&id=ed3266b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3266b2",
  null
  
)

export default component.exports